module.exports = __webpack_public_path__ + "media/images/logotipo-ef560e9f88430449ebe70bad22388612.svg";